import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DroplistWidget } from '@eforall/dashboard';
import { DeliveryEventsService } from '../delivery-events.service';
import { PastEventsViewPart } from './past-events/past-events-view.part';
import { UpcomingEventsViewPart } from './upcoming-events/upcoming-events-view.part';

@Component({
	selector: 'delivery-events-views-part',
	standalone: true,
	imports: [
		UpcomingEventsViewPart,
		PastEventsViewPart,
		DroplistWidget
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './events-views.part.html',
})
export class DeliveryEventsViewsPart implements OnInit {
	public pageService = inject(DeliveryEventsService);

	ngOnInit() {
		this.pageService.initializeUrl();
	}
}